import React, { useState } from "react";
import FileTag from "./FileTag";
import { AiOutlineMinus } from "react-icons/ai";
const MultiInputDataTag = ({
  label,
  length,
  name,
  defaultTitle,
  defaultParagraph,
  defaultImage,
  type,
  required,
}) => {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = (event) => {
    setVisibility(false);
  };
  return (
    <div
      key={Math.random()}
      className={visibility ? "" : "gap-1 items-end hidden"}
    >
      <div className="flex  gap-2 ">
        <label className="input-group flex-col gap-3">
          <label className="pt-5">
            <span className="text-md font-semibold p-0">
              {length ? label + " " + length : label}
            </span>
          </label>
          <input
            name={visibility ? name : ""}
            defaultValue={defaultTitle}
            type={type}
            className="input input-bordered w-full z-0"
            required={required}
          />
          <textarea
            rows={6}
            name={visibility ? name : ""}
            defaultValue={defaultParagraph}
            type="Text"
            className="textarea textarea-bordered  w-full"
            required={required}
          />
          <FileTag
            label={label}
            length={length}
            name={name}
            defaultValue={defaultImage}
            type={type}
          />
        </label>
        <div className="pt-14">
          <button
            type="button"
            onClick={handleDelete}
            className="btn  btn-sm h-[95%]"
          >
            <AiOutlineMinus />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultiInputDataTag;
